<template>
  <div id="whatIdo" class="mb-96 sm:mb-0">
    <section >
      <div class="md:h-screen">
        <div class="h-full flex flex-col justify-center">
          <div class="text-center mb-10 -mt-36 exp">
            <p>***</p>
            <p
              data-aos="fade-right"
              data-aos-offset="300"
              data-aos-duration="1000"
              data-aos-easing="ease-in-sine"
              class="font-bold scroll__sub__headers"
            >
              What I do
            </p>
          </div>
          <div
            class="
              space-y-4
              md:space-y-0
              flex flex-col
              md:flex-row
              items-center
              justify-center
              md:space-x-4
              text-slate-50
            "
          >
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-anchor-placement="bottom-bottom"
              :class="[ $root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg' ]"
              class=" p-5 w-36 rounded-lg"
            >
              <p 
              :class="[$root.isDarkMood ? 'text-slate-50' : 'text-gray-700']"
               class="text-lg py-14">
                Web <br />
                Designer
              </p>
              <div
                id="model_open_cta"
                @click="models(1)"
                class="flex items-center cursor-pointer seeMore space-x-2"
              >
                <span href="" class="text-sm text-sky-600">see more</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-anchor-placement="bottom-bottom"
              :class="[ $root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg' ]"
              class=" p-5 w-36 rounded-lg"
            >
              <p 
              :class="[$root.isDarkMood ? 'text-slate-50' : 'text-gray-700']"
               class="text-lg py-14">
                Frontend <br />
                Developer
              </p>
              <div
                id="model_open_cta"
                @click="models(2)"
                class="flex items-center cursor-pointer seeMore space-x-2"
              >
                <span href="" class="text-sm text-sky-600">see more</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-duration="3000"
              data-aos-anchor-placement="bottom-bottom"
              :class="[ $root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg' ]"
              class=" p-5 w-36 rounded-lg"
            >
              <p 
              :class="[$root.isDarkMood ? 'text-slate-50' : 'text-gray-700']"
               class="text-lg py-14">
                Backend <br />
                Developer
              </p>
              <div
                id="model_open_cta"
                @click="models(3)"
                class="flex items-center cursor-pointer seeMore space-x-2"
              >
                <span href="" class="text-sm text-sky-600">see more</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      id="model"
      class="
        md__box
        fixed
        inset-0
        bg
        model
        text-white
        flex
        justify-center
        items-center
        h-screen
      "
      :class="[showModels === 1 ? '' : 'invisible opacity-0']"
    >
      <div id="main_model" class="lg:w-1/2 mb-10 model_content p-4 rounded-lg">
        <svg
          @click="showModels = false"
          id="close_model"
          class="w-5 h-5 float-right cursor-pointer text-violet-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
        <p class="text-2xl font-bold text-gray-400 py-3 mb-8">Web Designer</p>
        <ul class="space-y-4">
          <li class="flex items-center text-violet-500">
            <svg
              class="w-10 h-10 md:w-6 md:h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Designing website deign templates using figma or adobeXd
          </li>
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Creating UX element interactions
          </li>
        </ul>
      </div>
    </div>
    <div
      id="model"
      class="
        md__box
        fixed
        inset-0
        bg
        model
        text-white
        flex
        justify-center
        items-center
        h-screen
      "
      :class="[showModels === 2 ? '' : 'invisible opacity-0']"
    >
      <div id="main_model" class="lg:w-1/2 mb-10 model_content p-8 rounded-lg">
        <svg
          @click="showModels = false"
          id="close_model"
          class="w-5 h-5 float-right cursor-pointer text-violet-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
        <p class="text-2xl font-bold text-gray-400 py-3 mb-8">
          Frontend Developer
        </p>
        <ul class="space-y-4">
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            SEO
          </li>
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Optimizing the user experience
          </li>
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Responsize Designs
          </li>
        </ul>
      </div>
    </div>
    <div
      id="model"
      class="
        md__box
        fixed
        inset-0
        bg
        model
        text-white
        flex
        justify-center
        items-center
        h-screen
      "
      :class="[showModels === 3 ? '' : 'invisible opacity-0']"
    >
      <div id="main_model" class="lg:w-1/2 mb-10 model_content p-8 rounded-lg">
        <svg
          @click="showModels = false"
          id="close_model"
          class="w-5 h-5 float-right cursor-pointer text-violet-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
        <p class="text-2xl font-bold text-gray-400 py-3 mb-8">
          Backend Developer
        </p>
        <ul class="space-y-4">
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            API
          </li>
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Linux Server
          </li>
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Databases
          </li>
          <li class="flex items-center text-violet-500">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Security
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModels: false,
    };
  },
  methods: {
    models(id) {
      this.showModels = id;
    },
  },
};
</script>

<style>
</style>